var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 3.33301L9.99998 9.99967M16.6666 3.33301V7.08301M16.6666 3.33301H12.9166M15.8333 10.4163V13.9997C15.8333 14.9331 15.8333 15.3998 15.6517 15.7563C15.4919 16.0699 15.2369 16.3249 14.9233 16.4847C14.5668 16.6663 14.1001 16.6663 13.1666 16.6663H5.99998C5.06656 16.6663 4.59985 16.6663 4.24333 16.4847C3.92973 16.3249 3.67476 16.0699 3.51497 15.7563C3.33331 15.3998 3.33331 14.9331 3.33331 13.9997V6.83301C3.33331 5.89959 3.33331 5.43288 3.51497 5.07636C3.67476 4.76275 3.92973 4.50779 4.24333 4.348C4.59985 4.16634 5.06656 4.16634 5.99998 4.16634H9.58331",
    stroke: "#4cd0cd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsLinkIcon);
export default __webpack_public_path__ + "static/media/statsLinkIcon.608d2e6c6e1ec2f55841482166a42df2.svg";
export { ForwardRef as ReactComponent };